var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#EA4335;}\n\t.st1{fill:#FBBC05;}\n\t.st2{fill:#4285F4;}\n\t.st3{fill:#34A853;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32.3,142.7l86,65.7c19.9-60.3,76.4-103.8,143.6-103.8c36.1,0,68.7,12.8,94.3,33.7L430.5,64 C385.2,24.4,327,0,261.8,0C160.6,0,73.9,58.1,32.3,142.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M110.5,256c0-16.6,2.8-32.6,7.7-47.5l-86-65.7C15.5,176.9,5.8,215.2,5.8,256s9.7,79.1,26.4,113.3l86-65.7 C113.3,288.6,110.5,272.6,110.5,256z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M261.8,209.5v98.9h137.3c-6.9,33.7-25.6,59.7-52.3,76.5l81.7,63.2c47-43.7,77.7-108.7,77.7-192.1 c0-15.1-2.3-31.4-5.8-46.5H261.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M346.8,384.9c-23.1,14.6-52.1,22.4-85,22.4c-67.2,0-123.9-43.5-143.7-104l-85.9,65.9 C73.9,453.9,160.6,512,261.8,512c62.4,0,122-22.3,166.7-63.9L346.8,384.9z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.66ec32251f47f5005ec4b0ff4c7800a7.svg";
export { ForwardRef as ReactComponent };